import '@fontsource/roboto/500.css';
import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    fontRoboto: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
    },

    logoutLink: {
      width: '52px',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '20px',
      color: '#FFFFFF',
      margin: '0',
      padding: '0',
      zIndex: 20,
    },

    fileDownloadLink: {
      fontWeight: 500,
      fontSize: '15px',
      lineHeight: '20px',
      zIndex: 20,
      float: 'left',
      marginRight: '4px',
    },
  },
  {
    name: 'Link',
  },
);
